import apiFetch from '../apiFetch'

export default function (unitId, token) {
  return apiFetch({ endPoint: `unit/${unitId}`, method: 'DELETE', body: null, token: token })
}
